<div class="logo-container">
    <div class="logo">
        <img src="../../../../assets/images/logo-tesi-blue.svg" alt="Loading Logo" class="h-18" />
    </div>
</div>

<div class="loading-dots">
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
</div>

